<template>
  <div class="px-2">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">รูปภาพ</th>
            <th class="text-left">พนักงาน</th>
            <th class="text-left">เวลา (เวลาท้องถิ่น)</th>
            <th class="text-left">สถานะ (work status)</th>
            <th class="text-left">อุปกรณ์ (device)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="transaction in transactions"
            :key="transaction.transaction_uuid"
          >
            <td
              class="py-4"
              :style="fullscreen ? 'width: 240px;' : 'width: 180px;'"
            >
              <div v-if="transaction.url_photo" style="position: relative">
                <v-img aspect-ratio="1" :src="transaction.url_photo"></v-img>
                <v-icon
                  color="white"
                  style="position: absolute; bottom: 0; right: 2px"
                  >mdi-camera
                </v-icon>
              </div>
              <div
                v-else-if="
                  transaction.employee &&
                  transaction.employee.url_photo_identifier
                "
                style="position: relative"
              >
                <v-img
                  aspect-ratio="1"
                  :src="transaction.employee.url_photo_identifier"
                ></v-img>
                <v-icon
                  color="white"
                  style="position: absolute; bottom: 0; right: 2px"
                  >mdi-folder-account
                </v-icon>
              </div>
              <div v-else style="position: relative">
                <v-img class="grey lighten-4" aspect-ratio="1"></v-img>
                <div
                  class="d-flex justify-center"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                  "
                >
                  <v-icon color="grey" size="64"> mdi-account </v-icon>
                </div>
              </div>
            </td>
            <td
              class="py-4"
              :style="
                fullscreen
                  ? 'width: 340px; vertical-align: top;'
                  : 'vertical-align: top;'
              "
            >
              <div v-if="transaction.employee">
                <p
                  class="subtitle-1 mb-0"
                  :style="fullscreen ? 'width: 340px; line-height: 1.2;' : ''"
                  :class="{ 'text-xl text-truncate': fullscreen }"
                >
                  {{ transaction.employee.firstname_th }}
                  {{ transaction.employee.lastname_th }}
                </p>
                <p class="grey--text" :class="{ 'text-lg mt-2': fullscreen }">
                  {{ transaction.employee.employee_code }}
                </p>
              </div>
            </td>
            <td
              class="py-4"
              :style="
                fullscreen
                  ? 'width: 320px; vertical-align: top;'
                  : 'vertical-align: top;'
              "
            >
              <div
                class="subtitle-1"
                :style="fullscreen ? 'line-height: 1.2;' : ''"
                :class="{ 'text-xl': fullscreen }"
                v-html="dateTimeFormat(transaction)"
              />
              <!-- <p class="grey--text" :class="{ 'text-lg mt-2': fullscreen }">
                {{ dateTimeFromNow(transaction.transaction_time) }}
              </p> -->
            </td>
            <td
              class="py-4"
              :style="
                fullscreen
                  ? 'width: 200px; vertical-align: top;'
                  : 'vertical-align: top;'
              "
            >
              <div v-if="transaction.company_duty">
                <p
                  class="subtitle-1 mb-0"
                  :style="fullscreen ? 'line-height: 1.2;' : ''"
                  :class="{ 'text-xl': fullscreen }"
                >
                  {{ transaction.company_duty.title_th }}
                </p>
                <p class="grey--text" :class="{ 'text-lg mt-2': fullscreen }">
                  {{ transaction.company_duty.duty_code }}
                </p>
              </div>
            </td>
            <td class="py-4" style="vertical-align: top">
              <div v-if="transaction.hardware">
                <p
                  class="subtitle-1 mb-0"
                  :style="fullscreen ? 'line-height: 1.2;' : ''"
                  :class="{ 'text-xl': fullscreen }"
                >
                  {{ transaction.hardware.title_th }}
                </p>
                <p class="grey--text" :class="{ 'text-lg mt-2': fullscreen }">
                  {{ transaction.hardware.hardware_code }}
                </p>
              </div>
              <div v-else>
                <p
                  v-if="transaction.transaction_source"
                  class="subtitle-1 mb-0"
                  :class="{ 'text-xl': fullscreen }"
                >
                  {{ transaction.transaction_source.title_short }}
                </p>
                <p class="grey--text" :class="{ 'text-lg mt-2': fullscreen }">
                  {{ transaction.device_code_3rdparty }}
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DeviceUseTableView',
  props: {
    fullscreen: {
      type: Boolean,
      required: true,
    },
    transactions: {
      type: Array,
      required: true,
    },
  },
  filters: {
    datetimeFormat(transaction) {
      return moment
        .utc(transaction.transaction_time)
        .utcOffset(transaction.timezone)
        .format('DD/MM/YYYY HH:mm:ss')
    },
  },
  methods: {
    dateTimeFormat(value) {
      return `<span>${moment
        .utc(value.transaction_time)
        .utcOffset(value.timezone)
        .format('DD/MM/YYYY')}</span> <span class="primary--text">${moment
        .utc(value.transaction_time)
        .utcOffset(value.timezone)
        .format('HH:mm:ss')}</span>`
    },
    dateTimeFromNow(value) {
      return moment(value).locale('th').fromNow()
    },
  },
}
</script>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}

.text-lg {
  font-size: 22px !important;
}
.text-xl {
  font-size: 28px !important;
}
</style>
